<template>
  <section>
    <div class="wizard-helper">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-row class="helper-left-content">
            <el-col :span="24">
              <slot name="left-content-title"></slot>
              <slot name="left-grid-content" v-if="$slots['left-grid-content']"></slot>
              <div class="grid-content" v-else>{{helperMessage}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24/steps.length" v-for="(step, idx) in steps" :key="idx">
              <span class="step-circle">{{idx + 1}}</span>
              <div class="grid-content display-inline-block">{{step}}</div>
              <i
                class="material-icons forward-arrow"
                v-if="idx !== steps.length-1"
              >keyboard_backspace</i>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="grid-action">
              <slot name="action"></slot>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" class="helper-right-content">
          <slot name="right-content-title"></slot>
          <slot name="right-grid-content" v-if="$slots['right-grid-content']"></slot>
          <div class="grid-content" v-else></div>
        </el-col>
      </el-row>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "WizardStepHelper",
  props: {
    helperMessage: {
      default: "",
      type: [String]
    },
    steps: {
      default: () => {
        return [];
      },
      type: [Array]
    }
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    clickActionButton() {
      this.$emit("click-action");
    }
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.wizard-helper {
  background: var(--denim-50);
  padding: 20px;

  >>> .el-col-6 {
    text-align: center;
    line-height: 26px;
  }

  .grid-content {
    margin: 5px 0px;
  }

  .grid-action {
    margin-top: 10px;
    text-align: center;

    >>> .el-dropdown {
      width: 100%;
    }
  }

  #wizard_checklist {
    width: 96px;
    height: 72px;
    margin: 25px;
  }

  .material-icons {
    margin: 4px;
    font-size: 8em;
    background: transparent;
    opacity: 0.5;
  }

  .icon-text-button {
    border: 1px solid #1a90fa;
    background: transparent;
    color: #409eff;
    padding: 0px 10px;

    span {
      color: #409eff;
    }
  }

  .step-circle {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: white;
    line-height: 20px;
    text-align: center;
    font-size: 1em;
    font-weight: 600;
    display: inline-block;
  }

  .icon-text-button .material-icons,
  .forward-arrow {
    font-size: 1.2em;
    vertical-align: middle;
    opacity: 1;
  }

  .forward-arrow {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wizard/helper/WizardStepHelper.vue